<template>
	<div id="simulator" class="vld-parent">

        <!-- <loading :active.sync="isLoading" :is-full-page="fullPage" loader="dots"></loading> -->
		<loading :show="isLoading"  :label="label"> </loading>

		<b-modal id="simulatorModal" ref="simulatorModal" title="Simulate working days">

			<b-form>
				<label class="mr-sm-2" for="simulator-days">Number of days to simulate</label>
				 <select class="form-control" v-model="n">
					<option v-for="n in 10" :value="n" :key='n'>{{n}}</option>
				 </select>
			</b-form>

			<div slot="modal-footer">
				<button type="button" class="btn btn-secondary" @click="hideModal">Cancel</button>
				<button type="button" class="btn btn-primary" @click="simulate">Simulate</button>
			</div>
		</b-modal>
	</div>
</template>

<script>
	import {mapState} from 'vuex'
	import * as randomPoint from "random-points-on-polygon";
	import * as turf from "@turf/turf";
	import moment from 'moment'
	import WorkersActions from "./Workers/Actions.js";
	import loading from 'vue-full-loading';

	export default {
		name: 'Simulator',
		mixins: [WorkersActions],
		components: {
            loading
        },
		data() {
			return {
				n: 1,
				sim_time: 0,
				isLoading: false,
				label: 'Simulating...',
				current_time: 0,
				muster_stopwatch: 0
			}
		},
		computed: {
			...mapState([
				'workers',
				'watcher',
				"move_watcher",
				'position',
				'worker_status',
				'features',
				'sprites',
				'path_features',
				'log',
				'paths',
				'zones',
				'vehicles',
				'proximity'
			]),
			alert: {
				get() { return this.$store.state.alert },
				set(value) {
					this.$store.commit('add_alert', value)
				}
			},
			time: {
				get() {
					return this.$store.state.time;
				},
				set(value) {
					this.$store.commit("setState", ["time", value]);
				}
			},
			day: {
				get() {
					return this.$store.state.day;
				},
				set(value) {
					this.$store.commit("setState", ["day", value]);
				}
			},
			start_time() {
				return this.$config.start_time
			},
			end_time() {
				return this.$config.end_time
			},
			sims() {
				return JSON.parse(JSON.stringify(this.$store.state.workers));
			},
			routines() {
				let routines = {};
				for (let worker_type in this.$config.routines) {
					let routine = this.$config.routines[worker_type];
					routines[worker_type] = {};
					for (let i in routine) {
						let key = i.split(':');
						key = moment().hour(key[0]).minute(key[1]).second(0).format("X") - moment().hour(this.start_time.hour).minute(this.start_time.minute).second(0).format('X');

						let next_key = this.$finder.next(routine, i);
						if (next_key) {
							next_key = next_key.split(':');
							next_key = moment().hour(next_key[0]).minute(next_key[1]).second(0).format("X") - moment().hour(this.start_time.hour).minute(this.start_time.minute).second(0).format('X');
						}
						else next_key = key;

						key = key+'|'+next_key;

						routines[worker_type][key] = this.$config.routines[worker_type][i]
					}
				}
				return routines;
			},
			muster: {
				get() {
					return this.$store.state.muster
				},
				set(value) {
					this.$store.commit('setState', ['muster', value])
				}
			},
		},
		methods: {
			hideModal() {
      			this.$refs.simulatorModal.hide()
			},
			simulate() {

				this.hideModal();
				this.$store.dispatch('end_time');
				this.isLoading = true;
				setTimeout(() => {
					this._simulate();
					this.isLoading = false;
				}, 200)

			},
			_simulate() {


				for (let d = 1; d <= this.n; d++) {

					this.current_time = this.time;

					this.muster = false;

					let muster_time = Math.round(this.$number.random(1200, 24000));
					let muster_duration = Math.round(this.$number.random(600, 1800));
					let muster_range = [muster_time, muster_time + muster_duration];
					this.muster_stopwatch = 0;


					let routines = JSON.parse(JSON.stringify(this.routines));
					for (let worker_type in routines) {
						let routine = routines[worker_type];
						let new_routine = {};
						let breakpoint = ['',''];
						for (let k in routine) {
							let range = k.split('|');
							let match = false;
							if (muster_range[0] >= parseInt(range[0])) {
								breakpoint[0] = k;
							}
							if (!breakpoint[1] && muster_range[1] <= parseInt(range[1])) {
								breakpoint[1] = k;
							}
						}

						let breakpoint_range;
						if (breakpoint[0]) {
							breakpoint_range = breakpoint[0].split('|');
							routine[breakpoint_range[0]+'|'+muster_range[0]] = routine[breakpoint[0]];


							if (breakpoint[1]) {
								breakpoint_range = breakpoint[1].split('|');
								if (breakpoint[1] != breakpoint[0]) routine[muster_range[1]+'|'+breakpoint_range[0]] = routine[breakpoint[1]];
								else routine[muster_range[1]+'|'+breakpoint_range[1]] = routine[breakpoint[1]];
								delete routine[breakpoint[1]];
							}
							delete routine[breakpoint[0]];
						}

						routine[muster_range.join('|')] = 'muster';

						let ordered = {};
						Object.keys(routine).sort((a, b) => {
							a = parseInt(a.split('|')[0]);
							b = parseInt(b.split('|')[0]);
							return a - b;
						}).forEach(key => {
							ordered[key] = routine[key];
						})


						routines[worker_type] = ordered;
					}

					if (this.watcher[this.day] == undefined) {
						this.$set(this.watcher, this.day, {});
						this.$set(this.move_watcher, this.day, {});
						for (let i in this.workers) {
							let worker = this.workers[i];
							let watcher = this.watcher[this.day];
							if (watcher[worker.id] == undefined) {
								this.$set(watcher, worker.id, []);
								this.$set(this.move_watcher[this.day], worker.id, []);
							}
						}
					}


					for (let i in this.sims){
						let worker = this.sims[i];
						let $sprite = this.sprites[worker.id];
						let watcher = this.watcher[this.day];


						if (watcher[worker.id] == undefined) {
							this.$set(watcher, worker.id, []);
							this.$set(this.move_watcher[this.day], worker.id, []);
						}
						if (this.worker_status[worker.id] == undefined) {
							this.$set(this.worker_status, worker.id, {'id': worker.id, zone_id: null, status: null, destination: [0,0]})
						}
						if (this.position[worker.id] == undefined) {
							this.$set(this.position, worker.id, {});
						}
						if (this.position[worker.id][this.day] == undefined) {
							this.$set(this.position[worker.id], this.day, []);
						}

						let worker_status = this.worker_status[worker.id];

						watcher = this.watcher[this.day][worker.id];
						let move_watcher = this.move_watcher[this.day][worker.id];
						let position = this.position[worker.id][this.day];
						let dt = 0;
						let move_dt = 0;
						this.sim_time = parseInt(this.time);


						// Clear injuries and alerts
						if (d == 1) {
							for (let key in this.$finder.all({worker_id: worker.id}, this.alert)) {
								this.$store.commit('clear_alert', {key: key, type: 'clear', day: this.day, time: this.sim_time, label: "Issue was Cleared at "+ this.$datetime.time(this.sim_time) + ".", type_label: 'Log and Clear'});
							}
							if (worker.status == 'injury') worker.status = 'at-zone';
						}

						if (worker.status == 'injury') continue;


						let routine = routines[worker.type];

						for (let k in routine) {
							let key = k.split("|");
							if (this.sim_time >= key[1] || routine[k] == 'start') {
								delete routine[k];
							}
							else {
								//if (routine[k] == 'start') delete routine[k];
								if (routine[k] == 'end') routine[k] = 'start';

								// let target_zones = this.$finder.all({ type: routine[k] }, this.zones );
								// let target = this.$finder.random(target_zones);

								// routine[k] = target;

							}
						}


						for (let k in routine) {

							let target = routine[k];

							let key = k.split('|');

							let timeframe = parseInt(key[1]) - parseInt(Math.max(key[0], 0));

							this.sim_time = Math.max(parseInt(key[0]), this.sim_time);

							if (worker.zone.type != target) {

								worker.target_zone_type = target;
								let target_zone = this._selectTargetZone(worker);

								worker.target_zone_id = target_zone.id;

								this._findPath(worker);

								if (!worker.route) {
									continue;
								}
								dt = this._logEvents(worker);

								//simulate events while whitin zones
								let pattern = this.$config.zone_types[worker.zone.type].movement;
								if (pattern == "stand" || pattern == "random") {
									this._findSpot(worker, true);
								}
								else if (pattern == "grouped") {
									var point = randomPoint(1, this.features[worker.zone.id].inner);
									worker.destination = point[0].geometry.coordinates;
								}

								dt = this._calculateTravelTime(worker);

								move_watcher.push(Object.freeze({type: 'move', zone_id: worker.zone.id, time: this.sim_time + dt.total, day: this.day, clock: this._clock(dt.total), label: 'moved within', class_type: 'light', muster: this.muster, destination: worker.destination, report: 'no'}));

								position.push({ floor_level: worker.floor_level, time: this.sim_time + dt.total, day: this.day, clock: this._clock(dt.total), coordinates: worker.destination, type: 'move'});

								this.sim_time += dt.total;
								move_dt = dt.total;
								worker.walking = true;


								let t = 0;
								dt = 0;
								let chance = 0;

								while (t < timeframe) {

									//this.setAlerts();

									if (timeframe > dt) {
										dt = 0;
									}


									if (worker.status == "at-zone" && (worker.zone.type == "work" || worker.zone.type == "restricted") ) {
										chance = Math.random();
										if (chance < worker.safety_chance_bad*60) {
											let rand = Math.random();
											if (rand <= 0.3333) {
												worker.target_zone_type = "restricted";
												let target_zone = this._selectTargetZone(worker);
												if (!target_zone) continue;
												worker.target_zone_id = target_zone.id;

												this._findPath(worker);
												if (!worker.route) continue;
												dt = this._logEvents(worker, t);

												t += dt.total;


											}
											if (rand > 0.3333 || (rand <= 0.3333 && !worker.path)) {
												if (rand <= 0.6666) {
													worker.status = "injury";
													worker.injury = "fall";
													watcher.push(Object.freeze({type: 'fall', zone_id: worker.zone.id, time: this.sim_time + t, day: this.day, clock: this._clock(t), label: 'fell from height at', alert: 1, class_type: 'danger'}));

												} else {
													worker.status = "injury";
													worker.injury = "man-down";
													watcher.push(Object.freeze({type: 'man-down', zone_id: worker.zone.id, time: this.sim_time + t, day: this.day, clock: this._clock(t), label: 'is down at', alert: 1, class_type: 'danger'}));

												}
											}

											this.setAlerts();

											t += Math.floor(Math.random() * 76) + 45;
											for (let key in this.$finder.all({worker_id: worker.id, 'status': 'pending'}, this.alert)) {

												if (this.alert[key].type == 'fall' || this.alert[key].type == 'man-down') {
													let label = ( this.alert[key].type == 'man-down' ?  'Security has arrived at location.' : "EMTs have been dispatched, asset is receiving medical care." );
													if (Math.random() > 0.35) this.$store.commit('alert_resolution', {key: key, type: 'notify_security', day: this.day, time: this.sim_time + t, label: label, type_label: 'Notify Security'});
												}
												else {
													if (Math.random() > 0.35) {
														this.$store.commit('alert_resolution', {key: key, type: 'buzz', day: this.day, time: this.sim_time + t, label: "Asset tag audio and light has been activated.", type_label: 'Buzz Asset'});

														this.$store.commit('exit_alert', {key: key, day: this.day, time: this.sim_time + t, type: 'exit', label: "Asset left zone at "+this.$datetime.time(this.sim_time) + t + "."});
													}
													else {
														// if (Math.random() < worker.safety_chance_good*60) {
															worker.target_zone_type = target;
															let target_zone = this._selectTargetZone(worker);
															worker.target_zone_id = target_zone.id;
															this._findPath(worker);

															dt = this._logEvents(worker, t);

															t += dt.total;

															this.$store.commit('exit_alert', {key: key, day: this.day, time: this.sim_time + t, type: 'exit', label: "Asset left zone at "+this.$datetime.time(this.sim_time) + t + "."});

														//}
													}
												}
												this.$store.commit('clear_alert', {key: key, type: 'clear', day: this.day, time: this.sim_time + t , label: "Issue was Cleared at "+ this.$datetime.time(this.sim_time + t) + ".", type_label: 'Log and Clear'});


											}
											if (worker.status == 'injury') worker.status = 'at-zone';


										}
									}

									// break event
									if (worker.status == "at-zone" && worker.zone.type == "work") {
										if (Math.random() < worker.chance_bad*60) {
											worker.target_zone_type = "break";
											let target_zone = this._selectTargetZone(worker);
											worker.target_zone_id = target_zone.id;
											worker.mode = "break";
											// worker.target_zone = this.$finder.random(this.$finder.all({ type: 'break' }, this.zones ));
											this._findPath(worker);

											if (!worker.route) continue;

											dt = this._logEvents(worker);
											t += dt.total;

											worker.target_zone_type = target.type;
											worker.target_zone_id = target.id;
											worker.mode = "normal";
											this._findPath(worker);

											t += Math.floor(Math.random() * 300) + 900;

											this._findPath(worker);

											if (!worker.route) continue;

											dt = this._logEvents(worker, t);

										}
									}

									t += 60;
								}

							}
							else if (worker.zone.type == 'start' && d > 1) {
								watcher.push(Object.freeze({type: 'entry', zone_id: worker.zone.id, time: this.sim_time, day: this.day, clock: this._clock(0), label: 'enters', alert: 0, class_type: 'success', muster: this.muster}));
							}

						}


						this._resetWorker(this.workers[worker.id]);
						this._resetWorker(worker);
						this.current_time = Math.max(this.current_time, this.sim_time);


					}

					this._resetVehicles();

					let event_id = this.$finder.next_id(this.log);
					let event = {type: 'muster', time: muster_time, id: event_id, status: 'end', end: muster_range[1], stopwatch: this.muster_stopwatch, day: this.day};
					this.$set(this.log, event_id, event);

					event_id = this.$finder.next_id(this.log);
					event = {type: 'eod', time: this.sim_time, id: event_id, day: this.day};
					this.$set(this.log, event_id, event);

					// generate random proximity alert events
					let proximity_count = this.$number.random(5,10);
					let candidates = [];
					for (let i in this.sims) {
						let worker = this.sims[i];
						let chance = 2;
						if (worker.safety <= 6) chance = 8;
						for (let j = 1; j <= chance; j++) {
							candidates.push(worker.id);
						}
					}

					for (let i = 1; i <= proximity_count; i++) {
						let a = this.$finder.random(candidates);
						let b = a;
						while (b == a) b = this.$finder.random(candidates);

						let pair = [a,b].sort(function(a, b){return a-b}).join("-");
						pair += "@"+this.day+":";

						let time = this.$number.randomInt(34000, 10);

						pair += time;

						let duration = this.$number.randomInt(60, 1800);


						let data = {'zone_id': null, 'workers': [a, b], 'day': this.day, 'time': time, 'clock': this._clock(time), 'status': 'clear', 'duration': duration};

						this.$set(this.proximity.alert, pair, data);
					}


					this.day++;
					this.time = 0;

				}

				for (let i in this.workers) {
					this.workers[i].simulation = false;
				}

			},
			_logEvents(worker, t) {
				if (!t) t = 0;
				let worker_status = this.worker_status[worker.id];
				let watcher = this.watcher[this.day][worker.id];
				let dt = this._calculateTravelTime(worker);
				let position = this.position[worker.id][this.day];

				let target_zone_id = worker.target_zone_id;
				let target_zone = this.zones[worker.target_zone_id];
				let muster = false;
				if (target_zone.type == 'muster') muster = true;

				watcher.push({type: 'travel', time: this.sim_time + dt.to_path, day: this.day, clock: this._clock(dt.to_path), label: "is traveling to", class_type: "primary", zone_id: worker.zone.id, target_zone_id: target_zone_id, travel_time: dt.total});

				// secondary iteration over route to log position
				if (worker.route) {
					worker.route.forEach((item, index) => {
						let path = item.path;
						let time_fraction = Math.round(dt.total / path.length);
						path.forEach(coord => {
							let time = time_fraction * (index + 1)
							position.push({ floor_level: worker.floor_level, time: this.sim_time + time, day: this.day, clock: this._clock(time), coordinates: coord, type: 'path'});
						})
					});
				}

				worker_status.traveling = false;


				let report = (worker.zone.type == 'parking') ? false : true;

				if (report) watcher.push(Object.freeze({type: 'exit', zone_id: worker.zone.id, time: this.sim_time + t + dt.to_path, day: this.day, clock: this._clock(dt.to_path), class_type: 'info', label: 'left'}));
				worker_status.zone_id = null;

				let alert = 0;
				let class_type = 'success';
				if (target_zone.type == 'restricted') {
					alert = 1;
					class_type = 'danger';
				}
				else if (target_zone.type == 'break') {
					alert = 2;
					class_type = 'warning';
				}


				report = (target_zone.type == 'parking') ? false : true;
				// console.log(worker.target_zone);
				if (report) watcher.push(Object.freeze({type: 'entry', zone_id: worker.target_zone_id, time: this.sim_time + t + dt.total, day: this.day, clock: this._clock(dt.total), label: 'enters', alert: alert, class_type: class_type, muster: muster}));

				worker.zone = target_zone;
				worker.polygon = this.features[worker.zone.id].turf;
				worker.target_zone_id = null;
				worker.route = null;
				worker.status = 'at-zone';
				worker.floor_level = worker.zone.floor_level;

				if (muster) this.muster_stopwatch = Math.max(this.muster_stopwatch, dt.total);

				if (!t) this.sim_time += dt.total;

				return dt;
			},
			_clock(time) {
				let clock = moment().add(this.day - 1, 'days').hour(this.start_time.hour).minute(this.start_time.minute).second(this.sim_time + time);
				return clock.format("M/D/YY h:mm:ssa");
			},
			_calculateTravelTime(worker) {

				let time = 0;
				let to_path = 0;

				if (worker.route) {
					worker.route.forEach(item => {
						let distance = item.length;
						let vehicle = item.vehicle;
						if (item.vehicle) {

							time += Math.round(distance * 1000 / vehicle.speed);
							time += Math.round(this.$number.random(30, 450)); // random number to simulate waiting time

						}
						else time += Math.round(distance * 1000 / worker.speed);
					});
				}
				else if (worker.zone.tool == 'MultiLineString' && worker.path) {
					let distance =  turf.length(turf.lineString(this.$geo.toTurf(worker.path)));
					let vehicle = this.vehicles[worker.vehicle_id];
					if (vehicle) {

						time += Math.round(distance * 1000 / vehicle.speed);
						time += Math.round(this.$number.random(30, 450)); // random number to simulate waiting time

					}
					else time += Math.round(distance * 1000 / worker.speed);

				}
				else if (worker.destination) {
					let distance = turf.distance(turf.point(this.toTurf(worker.coordinates)), turf.point(worker.destination));
					let vehicle = this.vehicles[worker.vehicle_id];
					if (vehicle) {

						time += Math.round(distance * 1000 / vehicle.speed);
						time += Math.round(this.$number.random(30, 450)); // random number to simulate waiting time

					}
					else time += Math.round(distance * 1000 / worker.speed);
				}

				to_path += Math.round(this.$number.random(30, 150)); // random number to simulate time to reach path first coordinate


				return {total: time + to_path, travel: time, to_path: to_path} ;

			},
			_resetWorker(worker) {
				let $sprite = this.sprites[worker.id];

				let target_zones = this.$finder.all({ type: 'start'	}, this.zones);

				worker.target_zone = null;
				worker.zone = this.$finder.random(target_zones);
				worker.status = 'at-zone';
				worker.floor_level = worker.zone.floor_level;
				worker.path = null;
				worker.route = null;
				worker.polygon = this.features[worker.zone.id].turf;
				worker.stairs_to = null;
				worker.override = false;
				worker.stairs_time = null;
				worker.end = false;
				worker.mode = "end";
				worker.alert = false;
				worker.destination = null;
				worker.in_vehicle = false;
				worker.vehicle_id = null;
				worker.driver_id = null;

				let point = [];

				if (worker.zone.tool == "Circle") {
					let a = Math.random() * 2 * Math.PI;
					let r = worker.zone.radius * Math.sqrt(Math.random());

					let x = r * Math.cos(a);
					let y = r * Math.sin(a);

					point = [x + worker.zone.center[0], y + worker.zone.center[1]]
				} else {
					point = randomPoint(1, worker.polygon);
					point = point[0].geometry.coordinates;
					point = ol.proj.transform(
						point,
						"EPSG:4326",
						"EPSG:3857"
					)
				}

				worker.simulation = true;
				worker.coordinates = point;
				$sprite.setCoordinate(point);
				$sprite.setState("idle");
				$sprite.setPath(null);
				$sprite.setDestination(point);
				worker.mode = "normal";
			},
			_resetVehicles() {

				for (let i in this.vehicles) {
					let vehicle = this.vehicles[i];

					let zone = this.$finder.first({'type': 'parking', 'terminal': '1', 'parking_vehicles': vehicle.type, 'companies': vehicle.company.id}, this.zones);

					if (!zone) continue;
					var feature = this.features[zone.id];

					let point = [];

					if (zone.tool == "Circle") {
						let a = Math.random() * 2 * Math.PI;
						let r = zone.radius * Math.sqrt(Math.random());

						let x = r * Math.cos(a);
						let y = r * Math.sin(a);

						point = [x + zone.center[0], y + zone.center[1]]
					} else {
						point = randomPoint(1, feature.turf);
						point = point[0].geometry.coordinates;
						point = ol.proj.transform(
							point,
							"EPSG:4326",
							"EPSG:3857"
						)
					}

					vehicle.floor_level = zone.floor_level;
					vehicle.path = null;
					vehicle.status = 'at-zone';
					vehicle.zone = zone,
					vehicle.queue = [],
					vehicle.on_board = [],
					vehicle.full = false
				}
			},
			toTurf(coords) {

				if (Array.isArray(coords[0])) {
					let result = [];
					for (let i in coords) {
						result.push(ol.proj.transform(
							coords[i],
							"EPSG:3857",
							"EPSG:4326"
						));
					}

					return result;
				}
				else {
					return ol.proj.transform(
						coords,
						"EPSG:3857",
						"EPSG:4326"
					)
				}
			},
			setAlerts() {

				for (let i in this.watcher[this.day]) {
					if (this.workers[i] == undefined) continue;
					let rec = this.watcher[this.day][i];
					let log = rec;
					for (let j in log) {
						let event = log[j];
						let alert = {};
						let zone = this.$finder.get('id='+event.zone_id, this.zones);
						let key = i+'-'+j+'-'+zone.id;
						if (event.alert == 1 && this.alert[key] == undefined) {
							alert = $.extend(true, {}, event);
							alert.zone_id = zone.id;
							alert.worker_id = this.workers[i].id;
							alert.worker = {id: this.workers[i].id, first_name: this.workers[i].first_name, last_name: this.workers[i].last_name}
							alert.status = 'pending';
							alert.id = key;
							alert.resolution = {};
							alert.result = {};
							alert.exit = {};
							this.$store.commit('add_alert', alert);
							this.workers[i].alert = true;

							this.$set(this.alert, key, alert);
							//this.show = true;
						}
						else if (event.type == 'exit') { // automatically clear restricted zone entry events

							let alerts = this.$finder.all({type: 'entry', zone_id: zone.id, worker_id: this.workers[i].id}, this.alert);
							for (let k in alerts) {
								if (alerts[k].day <= event.day && alerts[k].time <= event.time && !alerts[k].exit.key) this.$store.commit('exit_alert', {key: k, day: this.day, time: this.sim_time, type: 'exit', label: "Asset left zone at "+this.$datetime.time(this.time) + "."});
								this.workers[i].alert = false;
							}
						}
					}
				}

			},
			_selectTargetZone(worker) {

				let target_zones = this.$finder.all({
						type: worker.target_zone_type
					},
					this.zones
				);

				if (worker.target_zone_type == "end") {
					worker.target_zone_type = "start";
					worker.mode = "end";
					target_zones = this.$finder.all({
							type: "start"
						},
						this.zones
					);
				} else if (worker.target_zone_type == 'break') {
					for (var i in target_zones) {
						let distance = null;
						let curdistance;
						let selected_zone;
						let ref_distance;
						for (var i in target_zones) {
							if (worker.zone.id == target_zones[i].id) continue;
							ref_distance = ol.proj.transform(worker.coordinates, 'EPSG:3857', 'EPSG:4326');
							curdistance = turf.distance(ref_distance, this.features[target_zones[i].id].center);
							if (distance === null || curdistance < distance) {
								distance = curdistance;
								selected_zone = target_zones[i]
							}
						}
						if (selected_zone) target_zones = [selected_zone];
						else target_zones = false;
					}
				}

				for (let i in target_zones) {
					if (target_zones[i].companies && target_zones[i].companies.length) {
						if (!target_zones[i].companies.includes(worker.company.id)) delete target_zones[i];
					}
				}

				let target = this.$finder.random(target_zones);
				if (target == undefined) return null;

				return target;
			},
		}
	}
</script>
